// النصوص العربية لتطبيق الويب: العيش المشترك (golf 8). الشكل نفسه كما في samenApp.nl.ts. نبرة هادئة
// وناضجة: لا "دَين" ولا "نقاط" ولا نجوم.
export const appSamenAr = {
    words: {
        dinnerTitle: 'من سيتناول العشاء؟',
        dinnerTitleCohousing: 'الوجبة المشتركة',
        costsTitle: 'تقاسم التكاليف',
        costsTitleCohousing: 'التكاليف المشتركة',
        costsTitleCouple: 'الدفع معًا',
        costsTitleTwoHome: 'تكاليف الأطفال',
        emptyStudent: 'لا أحد بعد. هل نصنع التوست الليلة؟',
        emptyShared: 'لم يسجّل أحد بعد.',
        emptyCohousing: 'لا تسجيلات بعد.',
        formerShared: 'زميل سكن سابق',
        formerCohousing: 'ساكن سابق',
        formerFamily: 'فرد سابق من العائلة',
    },
    nav: {
        dinner: 'من سيأكل',
        dinnerCohousing: 'الوجبة المشتركة',
        bookings: 'الحجوزات',
        costs: 'التكاليف',
    },
    common: {
        save: 'حفظ',
        cancel: 'إلغاء',
        close: 'إغلاق',
        saved: 'تم الحفظ',
        you: 'أنت',
        left: '(غادر)',
        undo: 'تراجع',
        moreActions: 'المزيد',
    },
    dinner: {
        intro: 'من سيأكل الليلة، ومن يطبخ، وحتى متى يمكنك التسجيل.',
        emptyTitle: 'نأكل معًا؟',
        emptyBody: 'اختر موعدًا نهائيًا ومن سيطبخ.',
        start: 'ابدأ قائمة العشاء',
        started: 'قائمة العشاء جاهزة.',
        tonight: 'الليلة',
        headCook: 'الطبّاخ {name}',
        headNoCook: 'لا طبّاخ بعد',
        eaters: 'عدد الآكلين: {n}',
        guestsExtra: '(+{n} ضيف)',
        until: 'التسجيل حتى {time} (باقٍ {left})',
        closed: 'أُغلق التسجيل. اسأل {name}.',
        closedNoCook: 'أُغلق التسجيل.',
        openForYou: 'انتهى الموعد، لكن ما زال بإمكانك تعديل القائمة.',
        noDinner: 'لا عشاء مشترك اليوم',
        notDinnerDay: 'لا يوجد عشاء مشترك في هذا اليوم.',
        myChoice: 'اختياري',
        imIn: 'سآكل معكم',
        imOut: 'لا',
        noChoice: '—',
        guests: 'الضيوف',
        guestsHint: 'العدد فقط؛ بلا أسماء.',
        groupIn: 'سيأكل',
        groupOut: 'لن يأكل',
        groupUnknown: 'لم يختر بعد',
        sourceDefault: 'المعتاد',
        sourceHouse: 'إعداد البيت',
        sourceAway: 'غائب',
        sourceBoard: 'عبر اللوحة',
        sourceBy: 'حدّده {name}',
        sourceCook: 'يطبخ',
        setFor: 'لـ {name}',
        cookTitle: 'الطبخ',
        cookClaim: 'سأطبخ أنا',
        cookOther: 'شخص آخر يطبخ',
        cookRotation: 'العودة إلى الجدول',
        cookPick: 'من يطبخ؟',
        cookFromRotation: 'حسب الجدول',
        noDinnerSet: 'لا عشاء مشترك اليوم',
        noDinnerUndo: 'هناك عشاء مشترك في النهاية',
        note: 'ملاحظة الطبّاخ',
        noteHint: 'يراها الجميع في البيت، لكن ليس على اللوحة.',
        meal: 'على القائمة: {title}',
        groceries: 'إدخال المشتريات',
        listChanged: 'تغيّرت قائمة العشاء · أعد التقسيم',
        settings: 'إعدادات قائمة العشاء',
        cutoff: 'التسجيل حتى',
        cutoffHint: 'بين 10:00 و21:00.',
        days: 'أيام العشاء المشترك',
        houseDefault: 'من لم يختر بعد',
        houseDefaultUnknown: 'اسأل',
        houseDefaultIn: 'سيأكل',
        houseDefaultOut: 'لن يأكل',
        remind: 'تذكير قبل الموعد',
        remindOff: 'متوقف',
        remindMinutes: '{n} دقيقة',
        remindHours: '{n} ساعة',
        cookItem: 'مهمة الطبخ من الجدول',
        cookItemNone: 'لا شيء (تتولاها بنفسك)',
        myDefault: 'اختياري المعتاد',
        myDefaultHint: 'لكل يوم من أيام الأسبوع. اختيارك ليوم محدد له الأولوية دائمًا.',
        prefIn: 'نعم',
        prefOut: 'لا',
        prefAsk: 'اسألني',
        signedIn: '{name} سيأكل',
        signedOut: '{name} لن يأكل',
        cleared: 'أزيل الاختيار',
        closedToast: 'أُغلق التسجيل.',
        widgetAll: 'إلى قائمة العشاء',
        widgetNotYet: 'لم تختر بعد.',
        widgetYouIn: 'ستأكل معنا',
        widgetYouOut: 'لن تأكل معنا',
    },
    costs: {
        visibleAll: 'يرى الجميع في البيت المصاريف والأرصدة. لا تمرّ أي أموال عبر AMUMIN.',
        visibleTwoHome: 'يرى هذا الوالدان فقط. لا يرى الأطفال شيئًا. لا تمرّ أي أموال عبر AMUMIN. لا يظهر شيء على اللوحة إلا إذا أكّدت ذلك بنفسك صراحةً لجهاز لوحي معيّن، ويمكنك إزالته في أي وقت.',
        tabExpenses: 'المصاريف',
        tabBalance: 'الرصيد',
        tabSettled: 'المسوّى',
        add: 'مصروف',
        empty: 'لا مصاريف بعد.',
        emptyBody: 'أدخل مصروفًا؛ يحسب AMUMIN من يستحق ماذا.',
        rowPaid: 'دفعه {name}',
        rowFor: 'لـ {n}',
        new: 'جديد',
        edited: 'معدّل',
        questionBadge: 'سؤال مفتوح',
        locked: 'مغلق',
        loadMore: 'تحميل المزيد',
        deletedList: 'المحذوفة ({n})',
        deletedHint: 'يمكن استعادتها خلال 30 يومًا.',
        newTitle: 'مصروف جديد',
        editTitle: 'تعديل المصروف',
        amount: 'المبلغ',
        amountHint: 'مثلًا 12.50',
        amountInvalid: 'أدخل مبلغًا، مثلًا 12.50.',
        amountTooLarge: 'هذا المبلغ مرتفع جدًا.',
        ambiguous: 'هل تقصد {a} أم {b}؟',
        confirmLarge: 'هل {amount} صحيح؟',
        confirmLargeYes: 'نعم، صحيح',
        description: 'الوصف',
        descriptionHint: 'يراه الجميع في البيت',
        paidBy: 'دفعه',
        date: 'التاريخ',
        dateFuture: 'لا يمكن اختيار تاريخ في المستقبل.',
        dateLocked: 'هذه الفترة مغلقة (حتى {date}).',
        split: 'التقسيم',
        splitEqual: 'بالتساوي',
        splitWeights: 'بالنسبة',
        splitExact: 'بالضبط',
        splitDinner: 'الآكلون في {date}',
        splitDinnerHint: 'يُقسَّم على من أكل؛ ويُحسب الضيوف على من أحضرهم.',
        remaining: 'باقٍ {amount} للتقسيم',
        tooMuch: '{amount} زيادة',
        perPerson: 'لكل شخص',
        nobody: 'اختر شخصًا واحدًا على الأقل.',
        enteredBy: 'أدخله {name}',
        editedBy: 'عدّله {name} في {date}',
        edit: 'تعديل',
        delete: 'حذف',
        deleteConfirm: 'هل أنت متأكد؟',
        deleteBody: 'يمكنك استعادته خلال 30 يومًا.',
        deleted: 'تم الحذف',
        restore: 'استعادة',
        restored: 'تمت الاستعادة',
        question: 'هل هناك خطأ؟',
        questionAsked: 'سؤالك مسجّل على المصروف.',
        questionOpen: '{name} يسأل إن كان هذا صحيحًا',
        questionResolve: 'إنه صحيح',
        questionAdjust: 'تعديل',
        questionWithdraw: 'سحب السؤال',
        detailTitle: 'المصروف',
        lockedNote: 'هذا المصروف ضمن فترة مغلقة.',
        gets: 'يستحق {amount}',
        owes: 'عليه تسوية {amount}',
        even: 'الرصيد صفر',
        twoHomeOpen: 'باقٍ للتسوية: {amount}',
        suggestions: 'اقتراح للتسوية',
        suggestionLine: '{from} ← {to} {amount}',
        copy: 'نسخ النص',
        copied: 'تم النسخ',
        iPaid: 'لقد دفعت',
        wasPaid: 'تم الدفع',
        settleTitle: 'التسوية',
        settleHint: 'لا تمرّ أي أموال عبر AMUMIN؛ هذه مجرد ملاحظة.',
        settleSaved: 'سُجّل. ما زال على {name} التأكيد.',
        settleSavedConfirmed: 'سُجّل.',
        pending: 'تسويات بانتظار التأكيد',
        pendingLine: '{from} يقول إنه دفع {amount}',
        confirm: 'صحيح',
        reject: 'غير صحيح',
        waiting: 'بانتظار {name}',
        confirmed: 'مؤكّد',
        unconfirmed: 'غير مؤكّد',
        noLogins: 'ليس لدى {names} تسجيل دخول خاص بعد. حتى يقبلوا الدعوة، تدير أنت مصاريفهم وتُحتسب التسوية لهم فورًا (غير مؤكدة).',
        noLoginsOne: 'ليس لدى {names} تسجيل دخول خاص بعد. حتى تُقبل الدعوة، تدير أنت المصاريف وتُحتسب التسوية فورًا (غير مؤكدة).',
        inviteHousemates: 'دعوة شركاء السكن',
        removeSettlement: 'إزالة',
        carried: 'رصيد مُرحّل',
        closeTitle: 'إغلاق الفترة',
        closeBody: 'الإغلاق حتى {date}.',
        closeHelp: 'تُرحَّل الأرصدة المفتوحة. تُقفل السجلات الأقدم وتُحذف بعد 24 شهرًا من تاريخها.',
        closeButton: 'الإغلاق حتى {date}',
        closeQuestions: 'أجب أولًا عن الأسئلة المفتوحة ({n}).',
        closePending: 'أولًا التسويات المنتظرة ({n}).',
        closeNothing: 'لا شيء لإغلاقه بعد.',
        closed: 'أُغلق حتى {date}',
        lastClosed: 'آخر إغلاق حتى {date}',
        allSettled: 'تمت تسوية كل شيء',
        exportCsv: 'تصدير CSV',
        settledEmpty: 'لا تسويات بعد.',
        leaverWarn: 'لدى {name} مبلغ مفتوح قدره {amount}.',
        leaverHint: 'سوّوا هذا أولًا أو اتفقوا عليه معًا. يبقى الرصيد في النظرة العامة.',
        offWarn: 'سيتوقف تقاسم التكاليف. تُحفظ البيانات 12 شهرًا ثم تُحذف.',
        widgetGets: 'تستحق {amount}',
        widgetOwes: 'عليك تسوية {amount}',
        widgetEven: 'تمت تسوية كل شيء',
        widgetAll: 'إلى التكاليف',
        twoHomeConfirm: 'يعمل إذا كنتما والدَين في هذه الأسرة. لا يرى الأطفال شيئًا.',
        twoHomeConfirmYes: 'تشغيل',
    },
    bookings: {
        intro: 'الغسالة أو المجفف أو الغرفة أو سرير الضيوف: اعرف من يستخدمها ومتى.',
        empty: 'لا شيء للحجز بعد.',
        emptyBody: 'اختر ما تتشاركونه. يمكنك تغيير القواعد الافتراضية لاحقًا.',
        addKind: '+ {name}',
        day: 'اليوم',
        prevDay: 'اليوم السابق',
        nextDay: 'اليوم التالي',
        today: 'اليوم',
        free: 'متاح',
        mine: 'أنت',
        closedHours: 'مغلق',
        dstHour: 'تغيير الساعة',
        tapFree: 'اضغط على وقت متاح للحجز.',
        sheetTitle: 'حجز {resource}',
        start: 'يبدأ في',
        duration: 'المدة',
        forWho: 'لمن',
        book: 'احجز',
        booked: 'تم حجز {resource} {time}',
        fromDate: 'من',
        toDate: 'حتى (شاملًا)',
        maxNights: 'بحد أقصى {n} ليالٍ متتالية.',
        overlap: 'في {time} الدور لـ {name}. أقرب وقت متاح: {next}.',
        overlapNoNext: 'هذا الوقت محجوز بالفعل.',
        takeNext: 'خذ {time}',
        err: {
            past: 'لقد مضى هذا الوقت.',
            max_days_ahead: 'يمكن الحجز حتى {n} يومًا مقدمًا.',
            slot: 'اختر وقتًا على شبكة الـ {n} دقيقة.',
            dst_hour: 'هذا الوقت يقع في ساعة تغيير التوقيت. اختر وقتًا آخر.',
            max_minutes: 'بحد أقصى {duration} متتالية.',
            closed_hours: '{resource} متاحة من {from} إلى {until}.',
            quota: 'لديك هذا الأسبوع {n} حجوزات لـ {resource} بالفعل.',
            max_days: 'بحد أقصى {n} أيام متتالية.',
        },
        myTitle: 'حجوزاتي',
        myEmpty: 'لم تحجز شيئًا.',
        cancel: 'إلغاء الحجز',
        cancelled: 'أُلغي',
        done: 'انتهيت، أفرغه',
        freed: 'متاح من جديد',
        viaBoard: 'عبر اللوحة',
        cancelledBoard: 'أُلغي عبر اللوحة، {time}',
        manage: 'إدارة',
        manageTitle: 'أشياء للحجز',
        addThing: 'إضافة شيء',
        editThing: 'تعديل {name}',
        name: 'الاسم',
        kind: 'النوع',
        unit: 'الحجز حسب',
        unitSlot: 'فترة زمنية',
        unitDay: 'يوم كامل',
        slotMinutes: 'الفترة الزمنية',
        defaultMinutes: 'المدة الافتراضية',
        maxMinutes: 'الحد الأقصى المتتالي',
        maxDays: 'الحد الأقصى للأيام المتتالية',
        maxAhead: 'الحجز مقدمًا (أيام)',
        perWeek: 'لكل شخص أسبوعيًا',
        perWeekNone: 'بلا حد',
        openFrom: 'مفتوح من',
        openUntil: 'مفتوح حتى',
        alwaysOpen: 'مفتوح دائمًا',
        onBoard: 'على لوحة المدخل',
        archive: 'أرشفة',
        unarchive: 'استعادة',
        archived: 'مؤرشف',
        minutes: '{n} دقيقة',
        hours: '{n} ساعة',
        widgetNext: 'أنت: {resource} {time}',
        widgetFreeNow: '{resource}: متاح الآن',
        widgetBusyUntil: '{resource}: مشغول حتى {time}',
        widgetAll: 'إلى الحجوزات',
        kinds: {
            washer: 'الغسالة',
            dryer: 'المجفف',
            room: 'الغرفة',
            guest_bed: 'سرير الضيوف',
            other: 'أخرى',
        },
    },
    setup: {
        residents: 'كم عددكم؟',
        residentsLess: 'أقل',
        residentsMore: 'أكثر',
        shares: 'ماذا تتشاركون؟',
        shareNames: {
            kitchen: 'المطبخ',
            bathroom: 'الحمّام',
            laundry: 'الغسالة',
            dryer: 'المجفف',
            common_room: 'الغرفة المشتركة',
            guest_bed: 'سرير الضيوف',
            groceries: 'المشتريات',
            costs: 'التكاليف',
        },
        sameRights: 'يحصل زملاء السكن على الحقوق نفسها التي لديك.',
        housemates: 'زملاء السكن',
        housematesHint: 'أسماؤهم، فيظهرون فورًا في الجدول وقائمة العشاء.',
        housemateName: 'اسم زميل السكن {n}',
        housematesAdd: 'إضافة زملاء السكن',
        housematesAdded: 'زملاء السكن المضافون: {n}',
        housemateEmail: 'البريد الإلكتروني لشريك السكن {n} (اختياري)',
        invitesSent: 'الدعوات المرسلة: {n}',
        invitesLater: 'لم تُرسل الدعوة بعد. يمكنك ذلك لاحقًا في شركاء السكن.',
        oneByOne: 'أو شخص واحد على حدة (مثل طفل أو جليسة أطفال)',
        planTitle: 'هكذا نجهّز البيت',
        planBody: 'هذا ما سيُضاف. لا يُحذف شيء أبدًا؛ ما هو موجود يبقى كما هو.',
        planRooms: 'الغرف: {list}',
        planDuties: 'الجدول: {list}',
        planResources: 'الحجوزات: {list}',
        planDinner: 'قائمة العشاء: التسجيل حتى {time}',
        run: 'جهّز البيت',
        again: 'جهّز من جديد',
        againHint: 'يضيف فقط ما ينقص. لا يُحذف شيء.',
        doneToast: 'تم تجهيز البيت.',
        nothingNew: 'كل شيء كان موجودًا بالفعل.',
        offTitle: 'سيتوقف مكوّن يحتوي على بيانات',
        offDinner: 'سيتوقف «من سيأكل». تُحفظ البيانات 12 شهرًا ثم تُحذف.',
        offBookings: 'ستتوقف الحجوزات. تُحفظ البيانات 12 شهرًا ثم تُحذف.',
        csv: 'تنزيل التكاليف بصيغة CSV',
    },
    push: {
        dinner: 'من سيأكل',
        dinnerHint: '«هل ستأكل معنا؟» قبل الموعد، ويعرف الطبّاخ من سيحضر.',
        bookings: 'الحجوزات',
        bookingsHint: 'حجزك سيبدأ قريبًا، أو ألغى أحدهم على اللوحة.',
    },
    // Ronde 1 golf 8 (ON-3): huisgenoten per e-mail uitnodigen.
    invite: {
        title: 'دعوة {name}',
        body: 'يتلقى {name} رسالة فيها رابط ويختار كلمة مرور بنفسه. يحصل شركاء السكن على الصلاحيات نفسها التي لديك.',
        email: 'البريد الإلكتروني',
        send: 'إرسال الدعوة',
        sent: 'أُرسلت الدعوة إلى {email}',
        pending: 'مدعو: {email}',
        resend: 'إرسال مرة أخرى',
        taken: 'لدى هذا الشخص تسجيل دخول خاص به بالفعل.',
        already: 'هذا العنوان ينتمي بالفعل إلى هذا المنزل.',
        limit: 'أُرسلت اليوم 20 دعوة بالفعل. حاول مرة أخرى غدًا.',
        inUse: 'لهذا العنوان دعوة للمتابعة بالفعل. اسحبها أولًا.',
        loginNew: 'سجّل الدخول بكلمة المرور الجديدة. عنوان بريدك الإلكتروني مُدخل بالفعل.',
        hint: 'بدون تسجيل دخول خاص بعد: {names}. اضغط على اسم لدعوة ذلك الشخص عبر البريد الإلكتروني.',
        landingTitle: 'دعوة إلى منزلك',
        landingBody: 'يدعوك {inviter} إلى {household}. أنت فيه باسم {member}.',
        accepted: 'مرحبًا بك في {household}. يمكنك الآن استخدام التطبيق.',
    },
};
//# sourceMappingURL=samenApp.ar.js.map